const route = `{
    route(url: "terms-and-conditions.html") {
        ... on CmsPage {
            title
            content
        }
    }
}`;

export default {
    route,
};
